import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const WHY_CHOOSE_BG =
  'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=1920&auto=format&fit=crop';

const WhyChooseUs = () => {
  return (
    <Box
      id="options"
      sx={{
        position: 'relative',
        padding: { xs: '72px 20px', sm: '96px 40px', md: '120px 80px', lg: '140px 80px' },
        overflow: 'hidden',
        backgroundImage: `url(${WHY_CHOOSE_BG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'scroll',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(135deg, rgba(26, 35, 126, 0.88) 0%, rgba(40, 53, 147, 0.85) 50%, rgba(26, 35, 126, 0.9) 100%)',
          pointerEvents: 'none'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: { xs: '280px', md: '420px' },
          height: { xs: '280px', md: '420px' },
          background: 'radial-gradient(circle, rgba(255, 111, 0, 0.18) 0%, transparent 70%)',
          borderRadius: '50%',
          transform: 'translate(25%, 25%)',
          animation: 'pulse 4s ease-in-out infinite',
          pointerEvents: 'none'
        }
      }}
    >
      <Container maxWidth="xl" sx={{ width: '100%', position: 'relative', zIndex: 1 }}>
        <Box sx={{ 
          position: 'relative', 
          zIndex: 1,
          maxWidth: { xs: '100%', md: '800px', lg: '900px' },
          animation: 'fadeInUp 0.8s ease-out'
        }}>
          <Typography
            sx={{
              color: '#ff6f00',
              fontSize: { xs: '12px', md: '14px' },
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '3px',
              marginBottom: '20px',
              display: 'block',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            WHY CHOOSE US
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '32px', sm: '40px', md: '56px', lg: '72px' },
              fontWeight: 'bold',
              color: 'white',
              lineHeight: { xs: 1.2, md: 1.1 },
              marginTop: '16px',
              textShadow: '0 4px 12px rgba(0,0,0,0.3), 0 0 20px rgba(255, 111, 0, 0.2)'
            }}
          >
            Take on any Challenge of the
            <br />
            Car care
          </Typography>
        </Box>
      </Container>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: translate(30%, 30%) scale(1);
            opacity: 0.3;
          }
          50% {
            transform: translate(30%, 30%) scale(1.1);
            opacity: 0.5;
          }
        }
      `}</style>
    </Box>
  );
};

export default WhyChooseUs;
